import { SystemStyleObject } from '@chakra-ui/react';

export const dataTableFooterStyles: Record<string, SystemStyleObject> = {
  entityDirectory: {
    alignItems: 'center',
    bg: 'entityDirectory.surface',
    mt: 0,
    px: 4,
    py: 3,
  },
  entityDirectoryBordered: {
    alignItems: 'center',
    bg: 'entityDirectory.surface',
    borderTop: '1px solid',
    borderColor: 'entityDirectory.border',
    minH: '60px',
    mt: 0,
    px: '22px',
    py: '15px',
  },
};
